import _ from 'underscore'
import router from '../../router'
import LectureNote from '../../resources/lectureNote'
import {
  CREATE_LECTURE_NOTE_SUCCESS, RETRIEVE_LECTURE_NOTES_SUCCESS, IMPORT_MICRONOTES_SUCCESS
} from '../mutation-types'


const state = {};

const getters = {
  // Example
  allLectureNotes: (state) => {
    return _.values(state);
  }
}

const actions = {

}

const mutations = {
  LOGOUT_SUCCESS() {
    // Clear state
    for(let prop in state) Vue.delete(state, prop)
  },

  // [RETRIEVE_LECTURE_NOTES_SUCCESS] (state, payload) {
  //   console.log(`${RETRIEVE_LECTURE_NOTES_SUCCESS}`, payload)
  //   state.all = lectureNotes;
  // },

  [CREATE_LECTURE_NOTE_SUCCESS] (state, payload) {
    // console.log(`${CREATE_LECTURE_NOTE_SUCCESS}`, payload)
  },

  [IMPORT_MICRONOTES_SUCCESS](state, payload) {
    // console.log(`${IMPORT_MICRONOTES_SUCCESS}`, payload)
  },
}


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/lecture-notes.js